/* eslint-disable import/prefer-default-export */
import { ResourceMap, ResourceOptionsV3 } from 'medialoopster/rest';

import { RootState } from '../../../types/rootState';
import { ProductionContent } from './types';

export const getProductionContentResourceMap = (
  state: RootState,
): ResourceMap<ProductionContent, ResourceOptionsV3> => state.rest.productioncontent.objects;
